export default __webpack_public_path__ + "static/media/project2-p2.c6537daf.png";